module.exports = __webpack_public_path__ + "static/media/lato-latin-ext-300-normal.e9ac3d9b.woff";